export const SYNERGY_PATH_OBJ = {
    '/workflow/add': {path: '/workflow/request/RequestTypeShow.jsp', pathparam: ''},
    '/workflow/listDoing': {path: '/workflow/search/WFSearchResult.jsp', pathparam: 'scope=doing'},
    '/workflow/listDone': {path: '/workflow/search/WFSearchResult.jsp', pathparam: 'scope=done'},
    '/workflow/listMine': {path: '/workflow/search/WFSearchResult.jsp', pathparam: 'scope=mine'},
    '/workflow/supervise': {path: '/workflow/search/WFSuperviseList.jsp', pathparam: ''},
    '/workflow/agent': {path: '/workflow/request/wfAgentList.jsp', pathparam: 'scope=1'},
    '/workflow/monitorResult': {path: '/system/systemmonitor/workflow/WorkflowMonitorList.jsp', pathparam: ''},
    '/workflow/queryFlowResult': {path: '/workflow/search/WFSearchShow.jsp', pathparam: ''},
    '/workflow/req?iscreate=1': {path: '/workflow/request/AddRequest.jsp', pathparam: ''},
    '/workflow/req': {path: '/workflow/request/ViewRequest.jsp', pathparam: ''},

    '/document/add': {path: '/docs/docs/DocList.jsp', pathparam: ''},
    '/document/center': {path: '/docs/search/DocCommonContent.jsp', pathparam: 'scope=5'},
    '/document/search': {path: '/docs/search/DocCommonContent.jsp', pathparam: 'scope=14'},
    '/document/dummy': {path: '/docs/docdummy/DocDummyRight.jsp', pathparam: ''},
    '/document/subscribe': {path: '/docs/search/DocCommonContent.jsp', pathparam: 'scope=7'},
    '/document/share': {path: '/docs/search/DocCommonContent.jsp', pathparam: 'scope=13'},
    '/document/move': {path: '/docs/tools/DocCopyMove.jsp', pathparam: ''},
    '/document/monitor': {path: '/system/systemmonitor/docs/DocMonitor.jsp', pathparam: ''},
    '/document/edit': {path: '/docs/docs/DocAdd.jsp', pathparam: ''},
    '/document/detail': {path: '/docs/docs/DocDsp.jsp', pathparam: ''}
};

export const SYNERGY_WIDTH = '430px';


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/constants/Synergy.js